// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-2-fHY","main":"index-main-eAxf9"};